module.exports = __webpack_public_path__ + "img/44.92dc31c0.jpg";